var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"node-action"},[_vm._t("default"),_c('span',{on:{"click":_vm.deleteAction}},[_c('Trash')],1)],2)
}
var staticRenderFns = []

export { render, staticRenderFns }